module.exports = __webpack_public_path__ + "img/chapter__1_image_1.c21f1a76.png";